import React from "react";
import { Group, Text } from "@mantine/core";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";

interface SortableHeaderProps {
  column: any;
  label: string;
  ta?: "left" | "center" | "right";
}

const SortableHeader: React.FC<SortableHeaderProps> = (props) => {
  const { column, label, ta = "left" } = props;
  const isSorted = column.getIsSorted();
  return (
    <>
      <Group
        align="center"
        justify={ta === "right" ? "flex-end" : "space-between"}
        wrap="nowrap"
        // HIDE ON MOBILE
        className={"mantine-visible-from-xs"}
        onClick={column.getToggleSortingHandler()}
        px={4}
      >
        <Text size="sm" ta={ta}>
          {label}
        </Text>
        {isSorted === false && <SVGAsset name="sortingDefault" width={15} height={15} />}
        {isSorted === "asc" && (
          <SVGAsset name="chevron-right" width={20} height={20} style={{ transform: "rotate(90deg)" }} />
        )}
        {isSorted === "desc" && (
          <SVGAsset name="chevron-right" width={20} height={20} style={{ transform: "rotate(270deg)" }} />
        )}
      </Group>

      <Text
        // SHOW ON MOBILE
        size="sm"
        ta={ta}
        className={"mantine-hidden-from-xs"}
      >
        {label}
      </Text>
    </>
  );
};

export default SortableHeader;
